// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".OrderDetails__emptyState___F9QRl{color:var(--white70)}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/components/orderDetails/OrderDetails.scss"],"names":[],"mappings":"AAAA,kCACE,oBAAA","sourcesContent":[".emptyState {\n  color: var(--white70);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptyState": "OrderDetails__emptyState___F9QRl"
};
export default ___CSS_LOADER_EXPORT___;
